<template>
  <div :class="$style.certsList">
    <div :class="[$style.certs, $style[`certs${index+1}`]]" :key="index" v-for="(item, index) in certsList">
      <img :class="$style.certsImg" :src="item.certImg">
      <div :class="$style.content">
        <div :class="$style.title">{{ item.title }}</div>
        <div :class="[$style.intro, $style[`intro${j+1}`]]" v-for="(it, j) in item.intro" :key="j">
          <span :class="$style.dot"></span>
          {{ it }}
        </div>
        <div class="button-blue" :class="$style.btn" v-if="index === 1" @click="jump">了解详情</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCertsList } from './data'

export default {
  data () {
    return {
      certsList: getCertsList()
    }
  },
  methods: {
    jump () {
      window.open('https://ict.geekbang.com/')
    }
  }
}
</script>

<style lang="scss" module>
.certs {
  position: relative;
  display: flex;
  margin: 0 auto;
  width: 1400px;
  box-sizing: border-box;
}

.certs1 {
  margin-top: 40px;
  padding-right: 225px;
  justify-content: flex-end;

  .certsImg {
    position: absolute;
    top: -17px;
    left: 0;
  }

  .title {
    background: url(../../assets/img/number/01.png) no-repeat top 4px left 2px / 28px 23px;
  }
}

.certs2 {
  margin-top: 34px;
  padding-left: 18px;

  .certsImg {
    position: absolute;
    top: 0;
    right: 209px;
    order: 2;
  }

  .title {
    order: 1;
    padding-left: 44px;
    background: url(../../assets/img/number/02.png) no-repeat top 4px left 0 / 37px 24px;
  }

  .intro {
    margin-top: 30px;
  }

  .intro2 {
    margin-top: 24px;
  }

  .dot {
    left: 11px;
  }
}

.certsImg {
  width: 368px;
  height: 245px;
}

.content {
  width: 678px;
}

.title {
  padding-left: 40px;
  line-height: 33px;
  font-size: 24px;
  font-weight: 500;
  color: #404040;
}

.intro {
  position: relative;
  margin-top: 22px;
  padding-left: 40px;
  line-height: 28px;
  font-size: 15px;
  color: #404040;
}

.intro2 {
  margin-top: 16px;
}

.dot {
  position: absolute;
  top: 2px;
  left: 6px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #D1E6FF;

  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    width: 8px;
    height: 8px;
    background: #5286FF;
    border-radius: 50%;
  }
}

.btn {
  margin-top: 30px;
  margin-left: 41px;
}
</style>
